import { actionTypes } from 'redux-resource';
import { SubmissionError } from 'redux-form';

import NetworkError from 'helpers/networkErrorClass';
import * as api from '../api';

export const fetchQuickPortOuts =
  (page = 1) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'quickPortOuts',
      requestKey: `quickPortOuts_${page}`,
      list: `quickPortOuts_${page}`,
      mergeListIds: false,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .fetchQuickPortOuts({ page })
      .then(async (response) => {
        // const { count, next, previous, results } = response.data; // no pagination on backend for now
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: response.data,
          // resources: [results],
          // requestProperties: {
          //   perPage: results.length,
          //   count,
          //   next,
          //   previous
          // }
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
        });
        throw new NetworkError('Failed to load port outs.');
      });
  };

export const quickPortOutResolve = (portId, subId, action) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'quickPortOuts',
    requestKey: 'quickPortOutResolve',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.DELETE_RESOURCES_PENDING,
  });

  return api
    .quickPortOutResolve(subId, { action })
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.DELETE_RESOURCES_SUCCEEDED,
        resources: [portId],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.DELETE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError(messages);
    });
};
